
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dLoPa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9fb7c5548c3582e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $9fb7c5548c3582e1$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Skriv n\xe5got\xa0\u2026",
    'fabric.editor.editorAssistiveLabel': "Huvudsakligt inneh\xe5llsomr\xe5de, b\xf6rja skriva f\xf6r att ange text.",
    'fabric.editor.headingLink.toolbarHelpTitle': "\xd6ppna hj\xe4lpdialogruta"
};

});


//# sourceMappingURL=sv.e8d865e9.js.map
